<div class="api-error-container">
    <h2>ERROR</h2>
    <span class="primary-text">This error might be due to network connectivity or else some technical error.</span>
    <span class="secondary-text">Plz try again after sometime</span><br>
    <button class="try-again-btn" (click)="reloadPage()">Try Again</button>
</div>